import FilterTextField from '../baseInputTypes/FilterTextField'

export const GeneratorArrangement = () => {
  return (
    <FilterTextField
      label="Generator Arrangement"
      fieldPath={'productInformation.generatorArrangement'}
    />
  )
}
